import { Component, OnInit, Injectable } from '@angular/core';
import { conditionQuery } from './query-condition';
import { selectQuery } from './query-select';
import { sortQuery } from './query-sort.service';
import { filterQuery } from './query-filter';
import { relationQuery } from './query-relation';
import { ParseService } from './parse.service';
import { ProfilehelperDD } from '../helper/personaldetails-helper';
import { SessionHandler } from './session-handler';
import { StorageConfiguration } from '../storage-setting/storage-configuration';

@Injectable({
  providedIn: 'root'
})
export class QueryInterface {
  tenantId = '';

  constructor(
    private condition: conditionQuery,
    private select: selectQuery,
    private sort: sortQuery,
    private filter: filterQuery,
    private relation: relationQuery,
    private parseService: ParseService,
    private _helper: ProfilehelperDD,
    private sessionHandler: SessionHandler,
    private storageConfiguration: StorageConfiguration,
  ) { }

  async executeQuery(parseInstance, className, filterOptions: any[]) {
    let queryInstance = parseInstance.instance.Object.extend(className);
    let query = new parseInstance.instance.Query(queryInstance);
    this.setFilterOptionToQuery(query, filterOptions);
    const results = await query.find().catch(err => {
      this.sessionHandler.handleParseError(err)
    });
    return results;
  }


  async executeQueryWithRelation(parseInstance, className, filterOptions: any[]) {
    let queryInstance = parseInstance.instance.Object.extend(className);
    let query = new parseInstance.instance.Query(queryInstance);
    this.setFilterOptionToQuery(query, filterOptions);
    query.include('location')
    const results = await query.find()
      .catch(err => {
        this.sessionHandler.handleParseError(err)
      });
    return results;
  }


  async queryRole(parseInstance) {
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    let queryInstance = this.parseService.instance.Object.extend('TenantRole');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('tenantId', this.tenantId);
    query.ascending('displayName');
    let results = await query.find();
    if (results.length > 0) {
      return results;
    }
    else {
      let query = new parseInstance.instance.Query(parseInstance.instance.Role);
      query.equalTo('isActive', true);
      const results = query.find().catch(err => {
        this.sessionHandler.handleParseError(err)
      });
      return results;
    }
  }

  async queryRoleAll(parseInstance) {
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    let queryInstance = this.parseService.instance.Object.extend('TenantRole');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('tenantId', this.tenantId);
    query.ascending('displayName');
    let results = await query.find();
    if (results.length > 0) {
      return results;
    }
    else {
      let query = new parseInstance.instance.Query(parseInstance.instance.Role);
      query.ascending('name');
      const results = query.find().catch(err => {
        this.sessionHandler.handleParseError(err)
      });
      return results;
    }
  }

  async queryRoleName(parseInstance) {
    let data = [];
    let query = new parseInstance.instance.Query(parseInstance.instance.Role);
    query.equalTo('reportingTo', true);
    query.include('users')
    const results = query.find().catch(err => {
      this.sessionHandler.handleParseError(err)
    });
    return results;
  }

  async queryUserReporting(parseInstance, reportingToEmployee) {
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    if (this._helper.reportingtoLists.length > 0) {
      this._helper.reportingtoLists = [];
    }
    if (this._helper.reportingtoEmployee.length > 0) {
      this._helper.reportingtoEmployee = [];
    }

    let result = [];
    let query = new parseInstance.instance.Query(parseInstance.instance.Role);
    query.equalTo("reportingTo", true);
    query.equalTo("isActive", true);
    await query.find().then(async results => {
      for (let element of results) {
        let queryInstance = this.parseService.instance.Object.extend('Profile');
        let query = new this.parseService.instance.Query(queryInstance);
        query.equalTo('tenantId', this.tenantId);
        query.equalTo('isActive', true);
        query.equalTo('role', {
          __type: 'Pointer',
          className: '_Role',
          objectId: element.id
        });
        let res = await query.find();
        for (let innerElement of res) {
          let reporterId = innerElement.id
          let reporter = innerElement.get("firstName") + " " + innerElement.get("lastName");
          let isActive = innerElement.get("isActive")
          if (isActive == true) {
            this._helper.reportingtoEmployee.push({ id: reporterId, name: reporter, role: innerElement.get('role').get('name') });
            this._helper.reportingtoLists.push({ id: reporterId, name: reporter, role: innerElement.get('role').get('name') });
          }
        }
        if (reportingToEmployee) {
          result = this._helper.reportingtoEmployee
        }
        else {
          result = this._helper.reportingtoLists
        }
      }
    }).catch(err => {
      this.sessionHandler.handleParseError(err)
    });
    return result;
  }

  async getUserReporterList(result) {
    var reportingList = []
    await result
      .relation('users')
      .query()
      .include('profile')
      .each(function (obj) {
        reportingList.push(obj);
      });
    return reportingList;
  }



  async getQueryCount(parseInstance, className, filterOptions: any[]) {
    let queryInstance = parseInstance.instance.Object.extend(className);
    let query = new parseInstance.instance.Query(queryInstance);
    this.setFilterOptionToQuery(query, filterOptions);
    return await query.count();
  }




  async createQuery(parseInstance, className) {
    let queryInstance = parseInstance.instance.Object.extend(className);
    let newRecord = new queryInstance();
    return newRecord;

  }



  setFilterOptionToQuery(query, filterOptions) {
    for (var i = 0; i < filterOptions.length; i++) {
      switch (filterOptions[i].condition) {
        case 'equalTo': {
          this.condition.equalQueryCondition(query, filterOptions[i]);
          break;
        }
        case 'notEqualTo': {
          this.condition.notEqualQueryCondition(query, filterOptions[i]);
          break;
        }

        case 'greaterThan': {
          this.condition.greaterThanQueryCondition(query, filterOptions[i]);
          break;
        }

        case 'lessThan': {
          this.condition.lessThanQueryCondition(query, filterOptions[i]);
          break;
        }

        case 'lessThanOrEqualTo': {
          this.condition.lessThanOrEqualToQueryCondition(query, filterOptions[i]);
          break;
        }

        case 'greaterThanOrEqualTo': {
          this.condition.greaterThanOrEqualToQueryCondition(query, filterOptions[i]);
          break;
        }

        case 'containedIn': {
          this.condition.containedInQueryCondition(query, filterOptions[i]);
          break;
        }

        case 'notContainedIn': {
          this.condition.notContainedInQueryCondition(query, filterOptions[i]);
          break;
        }

        case 'containsAll': {
          this.filter.containsAllQueryCondition(query, filterOptions[i]);
          break;
        }

        case 'startsWith': {
          this.filter.startsWithQueryCondition(query, filterOptions[i]);
          break;
        }


        case 'fullText': {
          this.filter.fullTextQueryCondition(query, filterOptions[i]);
          break;
        }

        case 'matchesQuery': {
          this.relation.matchesQueryCondition(query, filterOptions[i]);
          break;
        }

        case 'doesNotMatchQuery': {
          this.relation.doesNotMatchQueryCondition(query, filterOptions[i]);
          break;
        }


        case 'select': {
          this.select.selectQueryCondition(query, filterOptions[i]);
          break;
        }


        case 'include': {
          this.select.includeQueryCondition(query, filterOptions[i]);
          break;
        }


        case 'limit': {
          this.sort.limitQueryCondition(query, filterOptions[i]);
          break;
        }


        case 'skip': {
          this.sort.skipQueryCondition(query, filterOptions[i]);
          break;
        }



        case 'ascending': {
          this.sort.ascendingQueryCondition(query, filterOptions[i]);
          break;
        }



        case 'descending': {
          this.sort.descendingQueryCondition(query, filterOptions[i]);
          break;
        }



        case 'exists': {
          this.sort.existsQueryCondition(query, filterOptions[i]);
          break;
        }



        case 'doesNotExist': {
          this.sort.doesNotExistQueryCondition(query, filterOptions[i]);
          break;
        }

        case 'contains': {
          this.sort.containsCondition(query, filterOptions[i]);
          break;
        }

        default: {
          //statements;
          break;
        }
      }
    }
  }

  async getCurrentRoleOfUser(roleId) {
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    let queryInstance = this.parseService.instance.Object.extend('TenantRole');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('role', { __type: 'Pointer', className: '_Role', objectId: roleId });
    query.equalTo('tenantId', this.tenantId);
    let results = await query.find();
    return results;
  }

  async getRoleDisplayName(roleId): Promise<any> {
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    const TenantRoleClass = this.parseService.instance.Object.extend('TenantRole');
    const tenantRoleQuery = new this.parseService.instance.Query(TenantRoleClass);
    tenantRoleQuery.equalTo('role', { __type: 'Pointer', className: '_Role', objectId: roleId });
    tenantRoleQuery.equalTo('tenantId', this.tenantId);
    let TenantRoleResult = await tenantRoleQuery.find();
    if (TenantRoleResult.length > 0) {
      return TenantRoleResult[0].get('displayName');
    } else {
      const _Role = this.parseService.instance.Object.extend('_Role');
      const role = new this.parseService.instance.Query(_Role);
      role.equalTo('objectId', roleId);
      let roleDetails = await role.find();
      return roleDetails[0].get('name');
    }
  }

  async getDepartmentUser(departmentId) {
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    let queryInstance = this.parseService.instance.Object.extend('TenantDepartment');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('department', { __type: 'Pointer', className: 'Department', objectId: departmentId });
    query.equalTo('tenantId', this.tenantId);
    let results = await query.find();
    if (results){
      return results[0];
    } else{
      return '';
    }
  }

}
